"use strict";
var React = require('react')
var Link = require('react-router')
var LanguageStore = require('../../store/LanguageStore')
var DocMeta = require('react-doc-meta');

var Reference = React.createClass({
componentDidMount() {
      LanguageStore.addChangeListener(this.onChange);
    },
    getInitialState() {
        var state = LanguageStore.getLanguage();
        return state;
    },
    onChange() {
        var state = LanguageStore.getLanguage();
        this.setState(state);
    },
  render() {
    return(this.state.lang === 'uk' ? this.eng() : this.state.lang === 'rs' ? this.srb() : this.state.lang === 'de' ? this.ger() : null)

  },
  componentWillUnmount() {
        LanguageStore.removeChangeListener(this.onChange);
    },
  srb(){
    document.title = 'Reference | Termovent SC Livnica čelika A.D. Bačka Topola'
      var tags = [
      {name: "description", content: "Termovent SC Livnica čelika A.D. svoje odlivke ugradila je u postrojenja referentnih kupaca kako na domaćem tržištu, tako i širom evrope."},
      {name: "keyword", content: "Termovent,celik,livnica,odlivak,reference, backa topola, srbija"},
      {itemProp: "name", content: "Reference | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {itemProp: "description", content: "Termovent SC Livnica čelika A.D. svoje odlivke ugradila je u postrojenja referentnih kupaca kako na domaćem tržištu, tako i širom evrope."},
      {itemProp: "image", content: "http://www.livnica.com/css/company_logo.png"},
      {name: "twitter:title", content: "Reference | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {name: "twitter:description", content: "Termovent SC Livnica čelika A.D. svoje odlivke ugradila je u postrojenja referentnih kupaca kako na domaćem tržištu, tako i širom evrope."},
      {name: "twitter:creator", content: "Termovent SC Livnica čelika A.D. Bačka Topola"},
      {name: "twitter:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "Reference | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:description", content: "Termovent SC Livnica čelika A.D. svoje odlivke ugradila je u postrojenja referentnih kupaca kako na domaćem tržištu, tako i širom evrope."},
      {property: "og:site_name", content: "Termovent SC Livnica čelika A.D. Bačka Topola"},
    ]
    return (
            <DocMeta tags={tags}>
      <div className='container'>
       <div className='index-content row '>
       <h1 className='onamaHeading text-center'>REFERENCE</h1><br/><br/>
       <p>Termovent SC Livnica čelika A.D. svoje odlivke ugradila je u postrojenja referentnih kupaca kako na domaćem tržištu, tako i širom evrope.</p><br/><br/>
         {this.reference()}
        </div>
      </div>
      </DocMeta>
    )
},
 eng(){
   document.title = 'References | Termovent SC Steal foundry J.S.C Backa Topola'
      var tags = [
      {name: "description", content: "Termovent SC steel foundry J.S.C had incorporated its castings in the plants of the reference customers both in the domestic market and across Europe."},
      {name: "keyword", content: "Termovent SC,Steel,foundry,casting,backa topola,serbia"},
      {itemProp: "name", content: "References | Termovent SC Steal foundry J.S.C Backa Topola"},
      {itemProp: "description", content: "Termovent SC steel foundry J.S.C had incorporated its castings in the plants of the reference customers both in the domestic market and across Europe."},
      {itemProp: "image", content: "http://www.livnica.com/css/company_logo.png"},
      {name: "twitter:title", content: "References | Termovent SC Steal foundry J.S.C Backa Topola"},
      {name: "twitter:description", content: "Termovent SC steel foundry J.S.C had incorporated its castings in the plants of the reference customers both in the domestic market and across Europe."},
      {name: "twitter:creator", content: "Termovent SC Steel foundry"},
      {name: "twitter:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "References | Termovent SC Steal foundry J.S.C Backa Topola"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:description", content: "Termovent SC steel foundry J.S.C had incorporated its castings in the plants of the reference customers both in the domestic market and across Europe."},
      {property: "og:site_name", content: "Termovent SC Steel foundry J.S.C"},
    ]
    return (
      <DocMeta tags={tags}>
      <div className='container'>
       <div className='index-content row '>
       <h1 className='onamaHeading text-center'>REFERENCES</h1><br/><br/>
       <p>Termovent SC steel foundry J.S.C  had incorporated its castings in the plants of the reference customers both in the domestic market and across Europe.</p><br/><br/>
       {this.reference2()}
        </div>
      </div>
      </DocMeta>
    )
  },
  ger(){
    document.title = 'Referenzen | Die Termovent SC Stahlfabrik GmbH'
      var tags = [
      {name: "description", content: "Die Gussformen der Termovent SC Stahlfabrik GmbH wird nicht nur von heimischen Firmen, sondern auch von Klienten in ganz Europa genutzt."},
      {name: "keyword", content: "Termovent SC,Stahlfabrik,Stahlgusse, Serbien"},
      {itemProp: "name", content: "Referenzen | Die Termovent SC Stahlfabrik GmbH"},
      {itemProp: "description", content: "Die Gussformen der Termovent SC Stahlfabrik GmbH wird nicht nur von heimischen Firmen, sondern auch von Klienten in ganz Europa genutzt."},
      {itemProp: "image", content: "http://www.livnica.com/css/company_logo.png"},
      {name: "twitter:card", content: "product"},
      {name: "twitter:site", content: "@publisher_handle"},
      {name: "twitter:title", content: "Referenzen | Die Termovent SC Stahlfabrik GmbH"},
      {name: "twitter:description", content: "Die Gussformen der Termovent SC Stahlfabrik GmbH wird nicht nur von heimischen Firmen, sondern auch von Klienten in ganz Europa genutzt."},
      {name: "twitter:creator", content: "Termovent SC Stahlfabrik GmbH"},
      {name: "twitter:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "Referenzen | Die Termovent SC Stahlfabrik GmbH"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:description", content: "Die Gussformen der Termovent SC Stahlfabrik GmbH wird nicht nur von heimischen Firmen, sondern auch von Klienten in ganz Europa genutzt."},
      {property: "og:site_name", content: "Die Termovent SC Stahlfabrik GmbH"},
    ]
    return (
      <DocMeta tags={tags}>
      <div className='container'>
       <div className='index-content row '>
       <h1 className='onamaHeading text-center'>REFERENZEN</h1><br/><br/>
       <p>Die Gussformen der Termovent SC Stahlfabrik GmbH wird nicht nur von heimischen Firmen, sondern auch von Klienten in ganz Europa genutzt. </p><br/><br/>
       {this.reference2()}
        </div>
      </div>
      </DocMeta>
    )
  },
  reference(){
    return(
           <div>
          <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/termovent.png" alt="Termovent SC" />
            <a href='http://www.termoventsc.co.rs/' target="_blank">
              <div className="caption text-left">
                <h5>Termovent SC Temerin</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">

            <img className='reference-img' src="img/reference/EPS.png" alt="Elektroprivreda Srbije" />
            <a href='http://www.eps.rs/SitePages/index.aspx' target="_blank">
              <div className="caption text-left">
                <h5>Elektroprivreda Srbije</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">

            <img className='reference-img' src="img/reference/ogranaktent.png" alt="TE Nikola Tesla - Obrenovac" />
            <a href='http://www.tent.rs/' target="_blank">
              <div className="caption text-left">
                <h5>TE Nikola Tesla - Obrenovac</h5>
              </div>
            </a>
            <a href='http://www.tent.rs/te-qkolubaraq' target="_blank">
              <div className="caption text-left">
                <h5>TE Kolubara - Veliki Crljeni</h5>
              </div>
            </a>
            <a href='http://www.tent.rs/te-qmoravaq' target="_blank">
              <div className="caption text-left">
                <h5>TE Morava - Svilajnac</h5>
              </div>
            </a>
          </div>
        </div>

      <div className="col-md-2 reference">
          <div className="thumbnail reference-link">

            <img className='reference-img' src="img/reference/kolubara.png" alt="Rudarski Basen Kolubara - Lazarevac" />
            <a href='http://www.rbkolubara.rs/' target="_blank">
              <div className="caption text-left">
                <h5>Rudarski Basen Kolubara - Lazarevac</h5>
              </div>
            </a>
          </div>
        </div>


        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/rudnikKovin.png" alt="Rudnik KOVIN - Kovin" />
            <a href='http://rudnikkovin.com/' target="_blank">
              <div className="caption text-left">
                <h5>Rudnik KOVIN - Kovin</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">

            <img className='reference-img' src="img/reference/gosa.png" alt="Goša fom - Smederevska Palanka" />
            <a href='http://www.gosafom.com/' target="_blank">
              <div className="caption text-left">
                <h5>Goša fom - Smederevska Palanka</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">

            <img className='reference-img' src="img/reference/rtbBor.png" alt="Rudarsko topioničarski basen - Bor" />
            <a href='http://rtb.rs/' target="_blank">
              <div className="caption text-left">
                <h5>Rudarsko topioničarski basen - Bor</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">

            <img className='reference-img' src="img/reference/yugoimport.png" alt="Jugoimport SDPR" />
            <a href='http://www.yugoimport.com/' target="_blank">
              <div className="caption text-left">
                <h5>Jugoimport SDPR</h5>
              </div>
            </a>
          </div>
        </div>
        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/gasteh.png" alt="Gasteh" />
            <a href='http://gasteh.com/' target="_blank">
              <div className="caption text-left">
                <h5></h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/fassi.png" alt="Viver Trading Limited - Limassol (Cyprus)" />
            <a href='http://www.fassi.com/' target="_blank">
              <div className="caption text-left">
                <h5>Viver Trading Limited - Limassol (Cyprus)</h5>
                <h6>FASSI GRU S.P.A. - Italy</h6>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/omsi.png" alt="Viver Trading Limited - Limassol (Cyprus)" />
            <a href='http://www.omsitrasmissioni.com/' target="_blank">
              <div className="caption text-left">
                <h5>OMSI Transmissioni S.p.A. - Italy</h5>

              </div>
            </a>
          </div>
        </div>




        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/gambarotta.png" alt="Gambarotta Gschwendt - Italy" />
            <a href='http://www.gambarotta.it/en/home.html' target="_blank">
              <div className="caption text-left">
                <h5>Gambarotta Gschwendt - Italy</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/cimolai.png" alt="CIMOLAI - Italy" />
            <a href='http://www.cimolai.com/index.php' target="_blank">
              <div className="caption text-left">
                <h5>CIMOLAI - Italy</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/arcelor.png" alt="ARCELOR MITTAL - Bosna i Hercegovina" />
            <a href='http://corporate.arcelormittal.com/' target="_blank">
              <div className="caption text-left">
                <h5>ARCELOR MITTAL - Bosna i Hercegovina</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/armature.png" alt="ARMATURE MUTA - Slovenia" />
            <a href='http://www.armature-muta.com/index.php?lang=en' target="_blank">
              <div className="caption text-left">
                <h5>ARMATURE MUTA - Slovenia</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/ot_logo.png" alt="OT industries - Hungary" />
            <a href='http://otindustries.eu/hu' target="_blank">
              <div className="caption text-left">
                <h5>OT INDUSTRIES - Hungary</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/pord.png" alt="PORD MAŠINOPROEKT - Macedonia" />
            <a href='http://pordmasinoproekt.com.mk/' target="_blank">
              <div className="caption text-left">
                <h5>PORD MAŠINOPROEKT - Macedonia</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/hitner.png" alt="HITTNER - Croatia" />
            <a href='http://hittner.hr/' target="_blank">
              <div className="caption text-left">
                <h5>HITTNER - Croatia</h5>
              </div>
            </a>
          </div>
        </div>




        </div>
    )
  },
   reference2(){
    return(
           <div>
          <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/termovent.png" alt="Termovent SC" />
            <a href='http://www.termoventsc.co.rs/' target="_blank">
              <div className="caption text-left">
                <h5>Termovent SC Temerin</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">

            <img className='reference-img' src="img/reference/EPS.png" alt="Elektroprivreda Srbije" />
            <a href='http://www.eps.rs/SitePages/index.aspx' target="_blank">
              <div className="caption text-left">
                <h5>Elektroprivreda Srbije</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">

            <img className='reference-img' src="img/reference/ogranaktent.png" alt="TE Nikola Tesla - Obrenovac" />
            <a href='http://www.tent.rs/' target="_blank">
              <div className="caption text-left">
                <h5>TE Nikola Tesla - Obrenovac</h5>
              </div>
            </a>
            <a href='http://www.tent.rs/te-qkolubaraq' target="_blank">
              <div className="caption text-left">
                <h5>TE Kolubara - Veliki Crljeni</h5>
              </div>
            </a>
            <a href='http://www.tent.rs/te-qmoravaq' target="_blank">
              <div className="caption text-left">
                <h5>TE Morava - Svilajnac</h5>
              </div>
            </a>
          </div>
        </div>

      <div className="col-md-2 reference">
          <div className="thumbnail reference-link">

            <img className='reference-img' src="img/reference/kolubara.png" alt="Rudarski Basen Kolubara - Lazarevac" />
            <a href='http://www.rbkolubara.rs/' target="_blank">
              <div className="caption text-left">
                <h5>Rudarski Basen Kolubara - Lazarevac</h5>
              </div>
            </a>
          </div>
        </div>


        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/rudnikKovin.png" alt="Rudnik KOVIN - Kovin" />
            <a href='http://rudnikkovin.com/' target="_blank">
              <div className="caption text-left">
                <h5>Rudnik KOVIN - Kovin</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">

            <img className='reference-img' src="img/reference/gosa.png" alt="Goša fom - Smederevska Palanka" />
            <a href='http://www.gosafom.com/' target="_blank">
              <div className="caption text-left">
                <h5>Goša fom - Smederevska Palanka</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">

            <img className='reference-img' src="img/reference/rtbBor.png" alt="Rudarsko topioničarski basen - Bor" />
            <a href='http://rtb.rs/' target="_blank">
              <div className="caption text-left">
                <h5>Rudarsko topioničarski basen - Bor</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">

            <img className='reference-img' src="img/reference/yugoimport.png" alt="Jugoimport SDPR" />
            <a href='http://www.yugoimport.com/' target="_blank">
              <div className="caption text-left">
                <h5>Jugoimport SDPR</h5>
              </div>
            </a>
          </div>
        </div>
        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/gasteh.png" alt="Gasteh" />
            <a href='http://gasteh.com/' target="_blank">
              <div className="caption text-left">
                <h5></h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/fassi.png" alt="Viver Trading Limited - Limassol (Cyprus)" />
            <a href='http://www.fassi.com/' target="_blank">
              <div className="caption text-left">
                <h5>Viver Trading Limited - Limassol (Cyprus)</h5>
                <h4>FASSI GRU S.P.A. - Italy</h4>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/omsi.png" alt="Viver Trading Limited - Limassol (Cyprus)" />
            <a href='http://www.omsitrasmissioni.com/' target="_blank">
              <div className="caption text-left">
                <h5>OMSI Transmissioni S.p.A. - Italy</h5>

              </div>
            </a>
          </div>
        </div>




        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/gambarotta.png" alt="Gambarotta Gschwendt - Italy" />
            <a href='http://www.gambarotta.it/en/home.html' target="_blank">
              <div className="caption text-left">
                <h5>Gambarotta Gschwendt - Italy</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/cimolai.png" alt="CIMOLAI - Italy" />
            <a href='http://www.cimolai.com/index.php' target="_blank">
              <div className="caption text-left">
                <h5>CIMOLAI - Italy</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/arcelor.png" alt="ARCELOR MITTAL - Bosna i Hercegovina" />
            <a href='http://corporate.arcelormittal.com/' target="_blank">
              <div className="caption text-left">
                <h5>ARCELOR MITTAL - Bosna i Hercegovina</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/armature.png" alt="ARMATURE MUTA - Slovenia" />
            <a href='http://www.armature-muta.com/index.php?lang=en' target="_blank">
              <div className="caption text-left">
                <h5>ARMATURE MUTA - Slovenia</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/ot_logo.png" alt="OT industries - Hungary" />
            <a href='http://otindustries.eu/hu' target="_blank">
              <div className="caption text-left">
                <h5>OT INDUSTRIES - Hungary</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/pord.png" alt="PORD MAŠINOPROEKT - Macedonia" />
            <a href='http://pordmasinoproekt.com.mk/' target="_blank">
              <div className="caption text-left">
                <h5>PORD MAŠINOPROEKT - Macedonia</h5>
              </div>
            </a>
          </div>
        </div>

        <div className="col-md-2 reference">
          <div className="thumbnail reference-link">
            <img className='reference-img' src="img/reference/hitner.png" alt="HITTNER - Croatia" />
            <a href='http://hittner.hr/' target="_blank">
              <div className="caption text-left">
                <h5>HITTNER - Croatia</h5>
              </div>
            </a>
          </div>
        </div>




        </div>
    )
  }
})

module.exports = Reference;



/** WEBPACK FOOTER **
 ** ./modules/components/Reference/Reference.js
 **/